
import React, { useState } from "react";
import TransactionTable from "./TransactionTable";
import TransactionSummary from "./TransactionSummary";
import { useTransactions } from "../../hooks/useTransactions";

const TransactionTabs = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  const active = tabs[activeTab];

  const { transactions, summary, loading } = useTransactions(
    active.api,
    active.params || {}
  );
  
  return (
    <div>
      {/* Tabs */}
      <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={`btn ${
              activeTab === index ? "btn-primary" : "btn-outline-primary"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* CUSTOM COMPONENT TAB */}
      {active.component ? (
        active.component
      ) : loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <TransactionSummary summary={summary} />
          <TransactionTable transactions={transactions} />
        </>
      )}
    </div>
  );
};

export default TransactionTabs;
